import Vue from 'vue';
import Router from 'vue-router';
import Main from './views/Main';
import About from './views/About';
import Contacts from './views/Contacts';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'main',
			component: Main
		},
		{
			path: '/about',
			name: 'about',
			//route level code-splitting
			//this generates a separate chunk (about.[hash].js) for this route
			//which is lazy-loaded when the route is visited.
			component: About
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: Contacts
		}
	]
});
